import { ReactElement } from 'react';
import { Font } from 'src/design-system/text/font';
import styles from './key-figures.module.scss';
// Interfaces
import { Slice } from '@utmb/types/slice-handler';
import { SliceRaceStatsView } from '@utmb/types/index';
// Utils
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'next-i18next';
import { KeyFigure } from '@utmb/features/key-figures/KeyFigure';
import { StyleEnum } from '@utmb/types/enum/StyleEnum';

export const KeyFigures = (props: Slice<SliceRaceStatsView>): ReactElement => {
    const { id, stats, isDark, style } = props;
    const { t } = useTranslation();

    return (
        <div
            id={id}
            className={[styles.kf_container, 'container', style === StyleEnum.BIG ? styles.big : styles.normal, isDark ? styles.isDark : ''].join(' ')}
        >
            {stats?.map((stat) => (
                <div className={styles.kf_block} key={uuidv4()}>
                    <Font.OxaniumRegular className={styles.kf_stat_value}>
                        <KeyFigure {...stat} isDark={isDark} />
                    </Font.OxaniumRegular>
                    <Font.OxaniumRegular className={styles.kf_stat_label}>{t(`races.keyfigures.${stat.name}`)}</Font.OxaniumRegular>
                </div>
            ))}
        </div>
    );
};
